import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

function InputCurrency(props) {
  const { name, inputRef, onChange, decimalScale, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={({ value }) => {
        onChange({
          target: {
            name,
            value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$ "
      decimalSeparator="."
      decimalScale={decimalScale}
      fixedDecimalScale={decimalScale !== undefined}
    />
  );
}

InputCurrency.propTypes = {
  name: PropTypes.string,
  inputRef: PropTypes.any,
  onChange: PropTypes.func,
  decimalScale: PropTypes.number,
};

InputCurrency.defaultProps = {
  decimalScale: undefined,
};

export default InputCurrency;
